import { shouldShowAssistantMessageActions } from '@/constants/chat'
import { buildAssistantRegenerateHandlers } from './buildAssistantRegenerateHandlers.js'

export function assistantBlockState(props) {
  const assistant = props.currentAssistant
  return {
    isOpenAgentQuestion: assistant.agentQuestion?.status === 'open',
    showMessageActions: shouldShowAssistantMessageActions(assistant),
    regen: buildAssistantRegenerateHandlers({
      activeThreadId: props.activeThreadId,
      exchangeId: props.exchangeId,
      activeQueryVersionIndex: props.activeQueryVersionIndex,
      onRegenerateAssistantVersion: props.onRegenerateAssistantVersion,
    }),
  }
}
